const DITypes = {
  JsonRpcDispatcher: Symbol('DealroadshowJsonRpcDispatcher'),
  DispatcherFactory: Symbol('DealroadshowDispatcherFactory'),
  AdapterFactory: Symbol('DealroadshowAdapterFactory'),
};

export default DITypes;
